module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<textarea class=\"w100\" readonly ")
    ; __append(escapeFn( Html.attribute("rows", column.rows) ))
    ; __append(">")
    ; __append(escapeFn( widget.item[column.name] === undefined ? "" : widget.item[column.name] ))
    ; __append("</textarea>")
  }
  return __output.join("");

}